import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

/**
 * Reference : https://outlookweb.visualstudio.com/Outlook%20Web/_git/client-web?path=%2Fpackages%2Fmail%2Fpackages%2Fmail%2Fowa-mail-search%2Flib%2Fselectors%2FgetIsSearchingWithinFromFolder.ts
 * Determines whether or not user is searching within a folder where it's more
 * common to use a "from:" prefix when searching for people.
 * @param folderId
 */
export const isSearchWithinFromFolder = (folderId: string) => {
    const folderName = folderId && folderIdToName(folderId);

    switch (folderName) {
        case 'sentitems':
        case 'drafts':
            return false;
    }

    return true;
};
